import {type} from 'arktype'

import call from '@/utils/api/call'

const tokenResponse = type({token: 'string'})
interface TokenApiResponse {
  data: typeof tokenResponse.infer
}

export async function getTwilioToken(): Promise<string> {
  const {data} = await call.get<TokenApiResponse>(`/twilio-inbrowser-api/token`)
  /*
  To test for local twilio ngrok development, please add headers like this:
  return call.get(`/twilio-inbrowser-api/token`, {
    headers: {'ngrok-skip-browser-warning': 'true'},
  })
    */
  const result = tokenResponse(data)
  if (result instanceof Error) {
    console.error('Invalid Twilio token response', result)
    throw new Error('Invalid token response format')
  }
  return result.token
}
